<!--首页消息通知提示-->
<template>
    <div>
        <div v-if="showGG" class="gonggao">
            <div>
                <div class="GGContent" @click="goActie">
                    <div>
                        <img src="../assets/images/images/GongGao.png">
                    </div>
                    <div class="tips">
                        <span>1条新通知</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
let me;
import { getData } from "../Interface/http.js";
export default {
    name:"GongGao",
    data(){
        return {
            showGG:false,
            nowID:''//当前接口返回的公告id
        }
    },
    methods: {
        goActie(){
            localStorage.setItem('GGID',me.nowID);
            me.$router.push({
                name:"articleDetail",
                query: { 
                    id: me.nowID,
                    active: 3
                }
            })
        },
        getMsgData(){//获取公告信息
            getData('/article/notice',{}).then(res=>{
                if(res.code=="0"){
                    var localID=localStorage.getItem('GGID');//获取本地存的id
                    if(res.data.id&&res.data.id!=localID){
                        me.showGG=true;
                        me.nowID=res.data.id;
                    }
                }
                
            })
        }
    },
    mounted() {
        me=this;
        this.getMsgData();
    }
}
</script>
<style scoped>
    .gonggao{
        width:100%;
        text-align:center;
        margin-top:5px;
        margin-bottom:2px;
    }
    .gonggao>div{
        width:160px;
        height:32px;
        border-radius:7px;
        display:inline-block;
        background-color:#666666;
    }
    .GGContent{
        display:flex;
        height:100%;
        justify-content:center;
        
    }
    .GGContent>div{
        height:100%;
    }
    .GGContent img{
        width:30px;
        height:100%;
        margin-right:5px;
    }
    .GGContent:nth-child(1){
        color:white;
        font-size:13px;
        
    }
    .tips{
        margin-left:5px;
        line-height:100%;
        display:flex;
        align-items:center;
    }
</style>